import { createComponent } from '@carvana/merch-components';
import {
  CommonSection,
  ContentContainer
} from '~/components/flp/Financing.styles';
import { appAssetsCdnUrl } from '~/constants/environment';

export const GraphicContainer = createComponent('div', {
  className:
    'relative flex flex-col sm:mt-0 sm:h-auto sm:basis-1/2 md:shrink-0 md:basis-[45%] lg:basis-[44%] xl:basis-[41%]'
});

export const HeroSection = createComponent(CommonSection, {
  className: 'relative overflow-hidden bg-none p-0'
});

export const HeroBackground = createComponent('div', {
  className:
    'absolute inset-0 z-0 h-[81%] overflow-hidden bg-cover bg-left-top bg-no-repeat sm:h-[300px] md:h-[260px]',
  style: {
    backgroundImage: `url(${appAssetsCdnUrl}/images/flp/marketing-hero-bg-xs.svg)`
  }
});

export const HeroContentWrapper = createComponent('div', {
  className:
    'z-1 w-full sm:px-3xl sm:py-8xl sm:pb-7xl md:px-4xl md:py-8xl xl:p-8xl'
});

export const HeroContentContainer = createComponent(ContentContainer, {
  className:
    'm-auto flex max-w-[unset] flex-col-reverse gap-4xl px-2xl pb-2xl pt-4xl sm:flex-row sm:items-start sm:justify-center sm:gap-[50px] sm:p-0 lg:gap-[68px] xl:gap-[140px]'
});

export const MonthlyPayment = createComponent('p', {
  className: 'text-icon-inverse t-heading-xl sm:t-heading-3xl'
});

export const Payment = createComponent('div', {
  className: 'flex flex-row items-center justify-center gap-sm'
});

export const Price = createComponent('div', {
  className:
    'absolute right-1/2 top-[6px] flex w-[160px] translate-x-[82%] flex-col items-center gap-sm rounded-xl border border-solid border-[#fff] p-xl sm:right-0 sm:top-[20px] sm:w-[220px] sm:translate-x-0 sm:p-2xl md:top-[35px] lg:top-[10px] lg:w-[260px] lg:p-3xl'
});

export const Label = createComponent('p', {
  className: 'text-icon-inverse t-label-xs sm:t-label-md lg:t-label-lg'
});

export const VehicleContainer = createComponent('div', {
  className:
    'relative z-1 flex min-h-[195px] overflow-visible sm:min-h-[300px] md:min-h-[347px]'
});

export const Footnote = createComponent('p', {
  className: 'text-center text-text-weak t-body-xs'
});

export const CopyContainer = createComponent('div', {
  className:
    'flex w-full flex-col items-center justify-center gap-2xl rounded-xl bg-white p-3xl px-2xl shadow-sm sm:flex-[0_0_340px] sm:items-start sm:gap-3xl md:flex-[0_0_468px] md:p-5xl md:px-6xl lg:flex-[0_0_588px] xl:flex-[0_0_624px]'
});

export const Copy = createComponent('div', {
  className: 'flex flex-col items-start gap-lg sm:gap-xl'
});

export const CopyHeading = createComponent('h2', {
  className: 'tracking-[-0.8px] text-text-strong t-brand-sm sm:t-brand-md'
});

export const CopyText = createComponent('p', {
  className: 'text-text-strong t-body-lg'
});

export const CopyStrong = createComponent('strong', {
  className: 't-strong-lg sm:inline'
});
